import Cookies from 'js-cookie';

export type MatchFilters = {
  tags: string[];
  maxCookTime: number | null;
  difficulty: string | null;
};

export const EMPTY_FILTERS: MatchFilters = { tags: [], maxCookTime: null, difficulty: null };

export type MatchSessionState = {
  readyUsernames: string[];
  totalMembers: number;
  matchedRecipeIds: number[];
  phase: 'LOBBY' | 'SWIPING';
  filters: MatchFilters;
};

export type MatchEventHandlers = {
  onSessionState: (state: MatchSessionState) => void;
  onPartnerReady: (username: string) => void;
  onSessionStart: () => void;
  onMatch: (recipeId: number) => void;
  onFiltersUpdated: (filters: MatchFilters) => void;
  onSessionReset: () => void;
};

function authHeader(): Record<string, string> {
  const token = Cookies.get('token');
  return { 'Authorization': `Bearer ${token}` };
}

export function postReady(): Promise<void> {
  return fetch(process.env.REACT_APP_BASE_PATH + '/match/ready', {
    method: 'POST',
    headers: authHeader(),
  }).then(r => { if (!r.ok) return Promise.reject(); });
}

export function postSwipeYum(recipeId: number): Promise<void> {
  return fetch(process.env.REACT_APP_BASE_PATH + '/match/swipe/' + recipeId, {
    method: 'POST',
    headers: authHeader(),
  }).then(r => { if (!r.ok) return Promise.reject(); });
}

export function postReset(): Promise<void> {
  return fetch(process.env.REACT_APP_BASE_PATH + '/match/reset', {
    method: 'POST',
    headers: authHeader(),
  }).then(r => { if (!r.ok) return Promise.reject(); });
}

export function putFilters(filters: MatchFilters): Promise<void> {
  return fetch(process.env.REACT_APP_BASE_PATH + '/match/filters', {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(filters),
  }).then(r => { if (!r.ok) return Promise.reject(); });
}

export function subscribeToMatchEvents(handlers: MatchEventHandlers): () => void {
  const token = Cookies.get('token');
  const url = process.env.REACT_APP_BASE_PATH + '/match/events?token=' + (token ?? '');
  const es = new EventSource(url);

  es.addEventListener('session_state', (e: MessageEvent) => {
    try {
      const data = JSON.parse(e.data);
      handlers.onSessionState({
        ...data,
        filters: data.filters ?? EMPTY_FILTERS,
      });
    } catch (_) {}
  });
  es.addEventListener('partner_ready', (e: MessageEvent) => {
    try { handlers.onPartnerReady(JSON.parse(e.data).username); } catch (_) {}
  });
  es.addEventListener('session_start', () => {
    handlers.onSessionStart();
  });
  es.addEventListener('match', (e: MessageEvent) => {
    try { handlers.onMatch(JSON.parse(e.data).recipeId); } catch (_) {}
  });
  es.addEventListener('filters_updated', (e: MessageEvent) => {
    try { handlers.onFiltersUpdated(JSON.parse(e.data)); } catch (_) {}
  });
  es.addEventListener('session_reset', () => {
    handlers.onSessionReset();
  });

  return () => es.close();
}
